const validateName = [
    {pattern: /^\D+$/, message: '不允许填写数字', trigger: 'blur'},
    {min: 2, max: 20, message: '长度在 2 到 20 个字', trigger: 'blur'}
]
const validatePhoneNum = [
    
    {
        pattern: /^1[345678]\d{9}$/,    //正则校验不用字符串
        message: "请填写正确的手机号码", trigger: "blur"
    }
]

const validatePass2 = (pass, rule, value, callback) => {
    if (value !== pass) {
        callback(new Error('两次输入密码不一致!'));
    } else {
        callback();
    }
};

function idCardValid(id) {
    // 1 "验证通过!", 0 //校验不通过
    var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
    //号码规则校验
    if (!format.test(id)) {
        return {'status': 0, 'msg': '身份证号码不合规'};
    }
    //区位码校验
    //出生年月日校验   前正则限制起始年份为1900;
    var year = id.substr(6, 4),//身份证年
        month = id.substr(10, 2),//身份证月
        date = id.substr(12, 2),//身份证日
        time = Date.parse(month + '-' + date + '-' + year),//身份证日期时间戳date
        now_time = Date.parse(new Date()),//当前时间戳
        dates = (new Date(year, month, 0)).getDate();//身份证当月天数
    if (time > now_time || date > dates) {
        return {'status': 0, 'msg': '出生日期不合规'}
    }
    //校验码判断
    var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);   //系数
    var b = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');  //校验码对照表
    var id_array = id.split("");
    var sum = 0;
    for (var k = 0; k < 17; k++) {
        sum += parseInt(id_array[k]) * parseInt(c[k]);
    }
    if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
        return {'status': 0, 'msg': '身份证校验码不合规'}
    }
    return {'status': 1, 'msg': '校验通过'}
}

function isHKCard(card) {
    // 港澳居民来往内地通行证
    // 规则： H/M + 10位或6位数字
    // 样本： H1234567890
    var reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
    if (reg.test(card) === false) {
        return {'status': 0, 'msg': '港澳居民来往内地通行证号码不合规'};
    } else {
        return {'status': 1, 'msg': '校验通过'};
    }
}


function isPassPortCard(card) {
    // 护照
    // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
    // 样本： 141234567, G12345678, P1234567
    var reg = /^([a-zA-z]|[0-9]){5,17}$/;
    if (reg.test(card) === false) {
        return {'status': 0, 'msg': '护照号码不合规'};
    } else {
        return {'status': 1, 'msg': '校验通过'};
    }
}

const validateCardId = (type, rule, value, callback) => {
    if (!type && value) {
        callback(new Error('请选择证件类型'));
        return
    }
    if (type === 1) {
        // 身份证
        const res = idCardValid(value)
        if (res && res.status !== 1) {
            callback(new Error('请输入正确的证件号码'));
        } else {
            callback()
        }
    } else if (type === 2) {
        // 护照
        const res = isPassPortCard(value)
        if (res && res.status !== 1) {
            callback(new Error('请输入正确的证件号码'));
        } else {
            callback()
        }
    } else if (type === 3){
        const res = isHKCard(value)
        if (res && res.status !== 1) {
            callback(new Error('请输入正确的证件号码'));
        } else {
            callback()
        }
    } else {
        callback()
    }
}

const validateAddress = [
    {min: 1, max: 30, message: '长度在 1 到 30 个字', trigger: 'blur'}
]

export {
    validateName,
    validatePhoneNum,
    validateAddress,
    validatePass2,
    validateCardId
}